<template>
  <div class="feed-card feed__infos-block">
    <div class="d-flex position-relative">
      <span class="v-line"></span>

      <div class="content">
        <GoogleMap
          :api-key="googleMapFrontApiKey"
          style="width: 100%; height: 300px"
          :center="{ lat: userActivity.data.latitude, lng: userActivity.data.longitude }"
          :zoom="20"
          :disable-default-ui="true"
        >
          <CustomMarker
            :options="{ position: { lat: userActivity.data.latitude, lng: userActivity.data.longitude } }"
          >
            <BeneficiaryMapIcon class="beneficiary-marker" />
          </CustomMarker>
        </GoogleMap>

        <div><h3> {{ $t('beneficiary_location.found.message') }} </h3></div>
        <div class="d-flex gap-2 align-items-center bg-white rounded p-3 mb-3">
          <span class="flex-shrink-0 svg-primary">
            <GeolocationMarker />
          </span>
          <div class="flex-fill lh-sm">{{ $t('beneficiary_location.found.address_inline', userActivity.data) }}</div>
        </div>

        <template v-if="userActivity.data.state === 'sent'">
          <ManualGeolocation v-if="modifyingGeolocation"
                             :userActivity="userActivity"
                             :subscription="subscription"
                             v-model:modifyingGeolocation="modifyingGeolocation"
                             />
          <template v-else>
            <div class="d-flex flex-column mt-2 mb-2 gap-1">
              <div class="flex-fill">
                <button @click="confirmGeolocation" name="button" type="submit" class="btn btn-light w-100">
                  <span class="default">
                  <CheckedSvg />

                  <span>{{ $t('beneficiary_location.confirm_btn_content') }}</span>
                  </span>
                </button>
              </div>
              <div class="flex-fill">
                <button @click="modifyGeolocation" name="button" type="button" class="btn btn-light w-100">
                  <span class="default">{{ $t('beneficiary_location.modify_btn_content') }}</span></button>
              </div>
            </div>
          </template>
        </template>

        <TimeInfos :userActivity="userActivity"/>
      </div>
    </div>
  </div>

<BeneficiaryLocationConfirmed v-if="userActivity.data.state === 'confirmed'":userActivity="userActivity"/>
</template>

<script setup>
import { ref } from 'vue';
import TimeInfos from '@components/utils/TimeInfos.vue';
import ManualGeolocation from './ManualGeolocation.vue';
import BeneficiaryLocationConfirmed from './BeneficiaryLocationConfirmed.vue';
import GeolocationMarker from '@images/GeolocationMarker.vue';
import CheckedSvg from '@images/CheckedSvg.vue';

import { sendAcCommand, googleMapFrontApiKey } from '@lib/utilities';
import { GoogleMap, CustomMarker } from 'vue3-google-map'
import BeneficiaryMapIcon from '@images/BeneficiaryMapIcon.vue';

const props = defineProps({
  userActivity: Object,
  subscription: Object
});

const modifyingGeolocation = ref(false);

const confirmGeolocation = () => {
  sendAcCommand(props.subscription, 'update_beneficiary_geolocation', {id: props.userActivity.id, event: 'confirm' })
};

const modifyGeolocation = () => {
  modifyingGeolocation.value = true
};
</script>
